import { StyledInput } from 'civic-champs-shared'
import { FieldProps, getIn } from 'formik'
import React from 'react'

//TODO the "meta" field appears to be missing as a known bug in formik@1.2 ???  Need `getIn` instead
export const NumberField = ({ field, form, ...props }: FieldProps<Number>) => {
  const touched = getIn(form.touched, field.name)
  const error = getIn(form.errors, field.name)

  return (
    <StyledInput
      {...props}
      value={field.value ? field.value.toString() : ''}
      onChange={(quantity: string) => {
        if (/^\d*$/.test(quantity)) {
          form.setFieldValue(field.name, quantity ? parseInt(quantity) : null)
        }
      }}
      error={touched && error ? error : undefined}
    />
  )
}
